<template>
  <div class="col-12 flex justify-center mt2 flex-column">
    <ParticipantCard v-if="showParticipantCard" class="mt2" />

    <SessionHeader :session="session" class="mt2" />

    <p v-if="isPaymentStep" class="h6">Annulation gratuite jusqu'à 48h avant le match.</p>
  </div>
</template>

<script setup>

import { computed } from 'vue';
import ParticipantCard from './ParticipantCard.vue';
import SessionHeader from './SessionHeader.vue';
import { useStore } from '@/store/index';

defineProps({
  showParticipantCard: {
    type: Boolean,
    default: false
  }
});

const store = useStore();

const session = computed(() => store.state.courtSettings.session);

const courtSettings = computed(() => store.state.courtSettings);
const currentStep = computed(() => courtSettings.value.currentStep);

const isPaymentStep = computed(() => currentStep.value === 'CourtPayment');
</script>
